

export const setTimeoutAsync = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
